<template>
    <div class="az-form-content">
      <div>
        <div class="li-tabela">
          <v-data-table
              :key="key"
              :headers="headersTabelaParticipantes"
              :total-items="totalItens"
              :items="itens"
              :pagination.sync="paginacaoInterna"
              no-data-text="Nenhuma Solicitação encontrada"
              :loading="false"
              hide-actions class="az-table-list"
          >
            <template  slot="items" slot-scope="props">
              <td :key="key" v-if="mostrarColunaAcoes">

                <div v-if="isSolicitacaoComAcaoClassificacaoHabilitada(props.item)">
                  <v-autocomplete
                             :ref="'autoComp'+props.item.id"
                             solo
                             hide-details
                             item-value="id"
                             item-text="numeracao"
                             v-model="props.item.classificacaoId"
                             :items="filterClassificacoes(props.item)"
                             @click="filterClassificacoes(props.item)"
                             @change="atribuirClassificacaoParticipante(props)"
                  />
                </div>
                <div v-else>
                  {{ props.item.classificacao ? props.item.classificacao : '--' }}
                </div>

              </td>
              <td>
                <div>
                  <p>
                    <strong>{{ props.item.fornecedor.razaoSocial }}</strong>
                    <br>
                    {{formatarIdentificacao(props.item.fornecedor)}}
                  </p>
                </div>
                <p></p>
              </td>
              <td>
                <span v-if="props.item.dataInteresse">{{ props.item.dataInteresse | az-date('DD/MM/YYYY HH:mm:ss')}}</span>
                <span v-else>-- / -- / --</span>
              </td>
              <td align="left" style="padding: 0 !important;">
                <situacao-pill :situationText="props.item.situacao"
                               :nomeFornecedor="props.item.fornecedor.razaoSocial"
                               :solicitacoes="props.item.fornecedor.documentos"></situacao-pill>
              </td>
              <td align="left" style="padding: 0 !important;">
                  <detalhe-itens-fornecedor :key="props.item.fornecedor.id" :casas-decimais="2" :classificacao="props.item.classificacao"
                                            :fornecedor="props.item.fornecedor" :itens-fornecedor="dadosItensFornecedor"
                                            :loading="estaCarregandoItensFornecedor"
                                            :numeroItensFornecedor="props.item.numeroItens"
                                            :quantidadeItensCredenciamento="quantidadeItensCredenciamento"
                                            @buscarItens="processarEventoBuscarItensFornecedor(props.item)"/>
              </td>
              <td>
                  <v-tooltip top>
                      <a slot="activator">
                          <v-icon size="15" @click="acessarTelaAnaliseDocumentacaoCredenciamento(props.item)">
                              search
                          </v-icon>
                      </a>
                      <span>Ver documentação do participante</span>
                  </v-tooltip>

                <v-tooltip v-if="props.item.situacao === 'NAO_CREDENCIADO'" top>
                  <a slot="activator">
                    <v-icon size="15" @click="abrirModalMotivoNaoCredenciarSolicitacaoCredenciamento(props.item)">
                      visibility
                    </v-icon>
                  </a>
                  <span>Ver Motivo</span>
                </v-tooltip>

                  <v-tooltip v-if="isSolicitacaoComAcaoBaixarTermoHabilitada(props.item)" top>
                      <a slot="activator" :href="criarLinkDownload(props.item.uriTermoCredenciamento)" target="_blank">
                          <v-icon size="15">get_app</v-icon>
                      </a>
                      <span>Baixar termo de credenciamento</span>
                  </v-tooltip>
                <v-tooltip top v-if="isSolicitacaoComAcaoSolicitarAssinaturaHabilitada(props.item)">
                  <a slot="activator" @click="solicitarAssinatura(props.item)" class="px-1">
                    <icone-assinar-documento/>
                  </a>
                  <span>Solicitar Assinatura</span>
                </v-tooltip>
              </td>
            </template>
          </v-data-table>
          <div class="az-pagination">
            <v-pagination v-model="paginacaoInterna.page" :length="paginas"/>
            <div class="az-select-pagination">
              <span>Linhas por página:</span>
              <v-select :items="linhasPorPagina" v-model="paginacaoInterna.rowsPerPage"/>
            </div>
          </div>
        </div>

        <modal-ver-motivo-nao-credenciamento
            v-if="isMostrarModalMotivoNaoCredenciarSolicitacaoCredenciamentoSelecionada"
            v-model="isMostrarModalMotivoNaoCredenciarSolicitacaoCredenciamentoSelecionada"
            titulo="Motivo Não Credenciamento"
            :motivo="motivoNaoCredenciarSolicitacaoCredenciamentoSelecionada"
            @fecharModalNaoCredenciamento="tratarEventoFecharModalMotivoNaoCredenciarSolicitacaoCredenciamento">
        </modal-ver-motivo-nao-credenciamento>
      </div>
    </div>
</template>

<script>

import SituacaoPill from '@/views/credenciamento/detalhe-credenciamento/commons/SituacaoPill.vue'
import {mapState} from 'vuex'
import {actionTypes, mutationTypes} from '@/commons/constants'
import ModalVerMotivoNaoCredenciamento
  from '@/views/credenciamento/detalhe-credenciamento/commons/ModalVerMotivoNaoCredenciamento.vue'
import DetalheItensFornecedor
  from "@/views/credenciamento/detalhe-credenciamento/orgao/components/DetalheItensFornecedor.vue";
import IconeAssinarDocumento from "@/commons/components/icones/IconeAssinarDocumento.vue";

function extrairNumeracao(cpfCnpj) {
  return cpfCnpj.replace(/\D/g, '');
}

export default {
        name: 'ListagemSelecaoParticipantes',
        components: {IconeAssinarDocumento, DetalheItensFornecedor, SituacaoPill, ModalVerMotivoNaoCredenciamento},
        props:['itens', 'paginacao', 'paginas', 'totalItens', 'quantidadeItensCredenciamento'],
        data() {
            return {
              paginacaoInterna: this.paginacao,
              linhasPorPagina: [10, 25, 50, 100],
              edicao: null,
              classificacoesDisponiveis: [],
              key: 0,
              newClassificacoesDisponiveis: [],
              numeracao: null,
              isMostrarModalMotivoNaoCredenciarSolicitacaoCredenciamentoSelecionada: false,
              motivoNaoCredenciarSolicitacaoCredenciamentoSelecionada: '',
              dadosItensFornecedor:{itens:[], totalGeral: null},
              estaCarregandoItensFornecedor: false
            }
        },
        async mounted() {
          this.edicao = this.$route.query.edicao
          setTimeout(async () => {
            await this.carregarClassificacoesParticipantes()
            await this.watchPesquisarClassificacoes()
          }, 150)
        },
        computed:{
          ...mapState(['analiseSolicitacaoCredenciamentoEmAnalise', 'licitacao']),
          isAnaliseSolicitacaoCredenciamentoEmAnalise() {
            return !!this.analiseSolicitacaoCredenciamentoEmAnalise && this.analiseSolicitacaoCredenciamentoEmAnalise.id
          },
          existeItensComAnalise() {
            return this.itens.some(item => !!item.analiseSolicitacaoCredenciamento && item.analiseSolicitacaoCredenciamento.id)
          },
          mostrarColunaAcoes() {
            return !!this.itens
          },
          headersTabelaParticipantes() {
            const headers = [
              {
                text: 'Classificação',
                align: 'left',
                sortable: false,
                value: 'classificacao',
                class: 'primary--text',
                width: '100px',
                visible: this.mostrarColunaAcoes
              },
              {
                text: 'Participante',
                align: 'left',
                sortable: false,
                width: '300px',
                value: 'fornecedor.razaoSocial',
                class: 'primary--text'

              },
              {
                text: 'Data Interesse',
                value: 'dataInteresse',
                sortable: false,
                align: 'left',
                width: '80px',
                class: 'primary--text'
              },
              {
                text: 'Situação',
                value: 'situacao',
                sortable: false,
                width: '100px',
                align: 'left',
                class: 'primary--text'
              },
              {
                text: 'Itens',
                value: 'itens',
                sortable: false,
                width: '100px',
                align: 'left',
                class: 'primary--text'
              },
              {
                text: 'Ações',
                value: 'situacao',
                sortable: false,
                align: 'left',
                class: 'primary--text',
                width: '100px',
                visible: this.mostrarColunaAcoes
              }
            ];
            return headers.filter(header => header.visible !== false);
          },
          credenciamentoId(){
            return this.licitacao.id
          },
          existeAlgumaAnaliseEmAndamento() {
              return !!this.analiseSolicitacaoCredenciamentoEmAnalise && this.analiseSolicitacaoCredenciamentoEmAnalise.situacao === 'EM_ANALISE'
          }
        },
        methods: {

          async watchPesquisarClassificacoes(){
            let itensCredenciados = this.itens.filter((item) => item.situacao === 'CREDENCIADO')

            for (const item of itensCredenciados) {

              await this.$watch(
                  () => {
                    const ref = this.$refs['autoComp' + item.id];
                    return ref ? ref.internalSearch : null;
                  },
                  async (val) => {
                    this.numeracao = val ? parseInt(val) : null
                    const params = {
                      pregaoId: this.credenciamentoId ? this.credenciamentoId : this.$route.params.id,
                      numeracao: this.numeracao
                    }
                    const dados = await this.$store.dispatch(actionTypes.CREDENCIAMENTO.SOLICITACAO.BUSCAR_CLASSIFICACOES_DISPONIVEIS, params)
                    this.newClassificacoesDisponiveis = dados.data.classificacoes
                  },
                  {
                    deep: true
                  }
              )
            }
          },

          async carregarClassificacoesParticipantes() {
            const params = {
              pregaoId: this.licitacao.id
            }
            await this.$store.dispatch(actionTypes.CREDENCIAMENTO.SOLICITACAO.BUSCAR_CLASSIFICACOES_DISPONIVEIS, params).then((dados) => {
              this.classificacoesDisponiveis = dados.data.classificacoes
              this.key++
            })
          },

          filterClassificacoes(item){

            if (this.newClassificacoesDisponiveis.length > 0){
              item.classificacoes = this.newClassificacoesDisponiveis.map((classificacao) => {
                return {id: classificacao.id, numeracao: classificacao.numeracao}
              })
            }

            if (this.classificacoesDisponiveis.length > 0) {
              item.classificacoes = this.classificacoesDisponiveis.map((classificacao) => {
                return {id: classificacao.id, numeracao: classificacao.numeracao}
              })
            }

            return item.classificacoes

          },

          async atribuirClassificacaoParticipante(props){

            const params = {
                pregaoId: this.licitacao.id,
                analiseSolicitacaoCredenciamentoId: this.analiseSolicitacaoCredenciamentoEmAnalise.id,
                solicitacaoCredenciamentoId: props && props.item ? props.item.id : '',
                classificacaoSolicitacaoCredenciamentoId: props && props.item ? props.item.classificacaoId : ''
            }

            await this.$store.dispatch(actionTypes.CREDENCIAMENTO.SOLICITACAO.ATRIBUIR_CLASSIFICACAO_AO_PARTICIPANTE, params)
            this.$emit('eventUpdate')

          },

          formatarIdentificacao(item) {
            const identificacao = item.cpfCnpj;
            const tipo = item.tipoPessoa;

            if (tipo === 'F') {
              return this.formatarCPF(identificacao);
            } else if (tipo === 'J') {
              return this.formatarCNPJ(identificacao);
            }
            return identificacao;
          },
          formatarCPF(cpf) {
            cpf = extrairNumeracao(cpf);
            return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
          },
          formatarCNPJ(cnpj) {
            if (!cnpj) return '';

            const cnpjLimpo = cnpj.replace(/[.\-/]/g, '');

            if (cnpjLimpo.length === 14) {
              if (/^\d{14}$/.test(cnpjLimpo)) {
                return cnpjLimpo.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
              } else if (/^[\w\d]{14}$/.test(cnpjLimpo)) {
                return cnpjLimpo.replace(/([\w\d]{2})([\w\d]{3})([\w\d]{3})([\w\d]{4})([\w\d]{2})/, '$1.$2.$3/$4-$5');
              }
            }

            return cnpj;
          },
          acessarTelaAnaliseDocumentacaoCredenciamento(item) {
            let route = {
              name: 'AnaliseDocumentacaoCredenciamento',
              params: {
                idSolicitacao: item.id,
                idAnaliseSolicitacao: this.analiseSolicitacaoCredenciamentoEmAnalise.id,
              },
            }

            if (this.edicao) {
              route.query =
                {
                  edicao: this.existeAlgumaAnaliseEmAndamento,
                  voltar: 'edicao'
                }
            }

            this.$router.push(route);

            const participante = {
              numeroProcesso: this.licitacao.numProcesso,
              orgao: item.fornecedor.razaoSocial,
              situacao: item.situacao,
            }

            this.$store.commit(mutationTypes.CREDENCIAMENTO.SET_PARTICIPANTE_CREDENCIAMENTO, participante);
          },
          isSolicitacaoComAcaoAnaliseHabilitada(solicitacaoCredenciamento) {
            return this.isAnaliseSolicitacaoCredenciamentoEmAnalise &&
                (this.isSolicitacaoCredenciamentoAguardandoAnalise(solicitacaoCredenciamento) ||
                solicitacaoCredenciamento.situacao === 'NAO_CREDENCIADO')
          },
          isSolicitacaoComAcaoClassificacaoHabilitada(solicitacaoCredenciamento) {
            return this.edicao && solicitacaoCredenciamento.situacao === 'CREDENCIADO' &&
                this.isSolicitacaoCredenciamentoEmAnalise(solicitacaoCredenciamento)
          },
          isSolicitacaoComAcaoBaixarTermoHabilitada(solicitacaoCredenciamento) {
            return solicitacaoCredenciamento.situacao === 'CREDENCIADO' &&
                !!solicitacaoCredenciamento.analiseSolicitacaoCredenciamento
          },
          isSolicitacaoCredenciamentoAguardandoAnalise(solicitacaoCredenciamento) {
            return solicitacaoCredenciamento.situacao === 'AGUARDANDO_ANALISE' &&
                !solicitacaoCredenciamento.analiseSolicitacaoCredenciamento
          },
          isSolicitacaoCredenciamentoEmAnalise(solicitacaoCredenciamento) {
            return solicitacaoCredenciamento.situacao !== 'AGUARDANDO_ANALISE' &&
                !!solicitacaoCredenciamento.analiseSolicitacaoCredenciamento &&
                solicitacaoCredenciamento.analiseSolicitacaoCredenciamento.situacao === 'EM_ANALISE'
          },
          isSolicitacaoComAcaoSolicitarAssinaturaHabilitada(item) {
            return item.situacao === 'CREDENCIADO' && !item.assinaturaSolicitada && item.idVirtualizado;
          },
          abrirModalMotivoNaoCredenciarSolicitacaoCredenciamento(solicitacaoCredenciamento) {
            this.motivoNaoCredenciarSolicitacaoCredenciamentoSelecionada = solicitacaoCredenciamento.motivoNaoCredenciamento
            this.isMostrarModalMotivoNaoCredenciarSolicitacaoCredenciamentoSelecionada = true
          },
          tratarEventoFecharModalMotivoNaoCredenciarSolicitacaoCredenciamento() {
            this.isMostrarModalMotivoNaoCredenciarSolicitacaoCredenciamentoSelecionada = false
          },

            async processarEventoBuscarItensFornecedor({id, fornecedor}){
                this.estaCarregandoItensFornecedor = true

                const data = {
                    solicitacaoCredenciamentoId: id,
                    fornecedorId: fornecedor.id,
                    credenciamentoId: this.credenciamentoId
                }

                const dataResposta = await this.$store.dispatch(actionTypes.CREDENCIAMENTO.ANALISE_SOLICITACAO_CREDENCIAMENTO.BUSCAR_DETALHE_ITENS_FORNECEDOR, data)

                Object.assign(this.dadosItensFornecedor, dataResposta)

                this.estaCarregandoItensFornecedor = false
            },
          async solicitarAssinatura(item) {
            this.habilitarLoadingGlobal()
            try {
              const params = {
                solicitacaoCredenciamentoId: item.id,
              }
              await this.$store.dispatch(actionTypes.CREDENCIAMENTO.SOLICITACAO.SOLICITAR_ASSINATURA, params)
              this.mostrarNotificacaoSucessoDefault()
              this.$emit('eventUpdate')
              this.desabilitarLoadingGlobal()
            } catch (e) {
              this.desabilitarLoadingGlobal()
            }
          }
        },
        watch: {
          paginacaoInterna: {
            handler(novoValor) {
              this.$emit('paginar', novoValor)
            },
            deep: true,
          },
        }
    }
</script>
<style scoped lang="stylus">
  .background-pill
    color white
    font-weight bold
    padding 5px
    background #9191918a
    border-radius calc(20px / 2)
    white-space nowrap
    margin 0 2rem

  .custom-select .v-select__slot
    border 1px solid #9191918a !important
    border-radius 4px !important
    padding 4px 8px !important

  .custom-select .v-input__append-inner
    margin-right -8px


</style>
